import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import MasterLayout from "../../masterLayout/MasterLayout";
import FormSucursal from "../../components/sucursal/FormSucursal";
import Loader from "../../components/Loader";
import { formSchema } from "../../validaciones/validacionSucursales";

const DetalleSucursalPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null)
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState({
    id,
    nombre: '',
    calle: '',
    num_exterior: '',
    num_interior: '',
    colonia: '',
    codigo_postal: '',
    ciudad: '',
    estado: '',
    lat: 0.0,
    lon: 0.0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatos({ ...datos, [name]: value });
  };

  const handleSave = () => {
    const result = formSchema.safeParse(datos);
    if (!result.success) {
      console.log(result.error.errors);
      console.log(result.error.flatten().fieldErrors);
      setError(result.error.flatten().fieldErrors)
      return;
    }
    else{
      setError(null)
    }
    // eslint-disable-next-line
    if (id == 0) {
      // Create new sucursal
      try {
        fetch("/p_sucursal",{
          method: "POST",
          headers:{
            "Content-Type": "application/json",
          },
          body: JSON.stringify(datos)
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if(data.status === 1){
            // Success
            navigate(-1);
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
      
    }
    else{
      // Update existing sucursal
      try {
        fetch("/p_sucursal",{
          method: "PUT",
          headers:{
            "Content-Type": "application/json",
          },
          body: JSON.stringify(datos)
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if(data.status === 1){
            // Success
            navigate(-1);
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };
  
  useEffect(() => {
    // eslint-disable-next-line
    if (id != 0) {
      try {
        fetch("/p_sucursal",{
          method: "PATCH",
          headers:{
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id })
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if(data.status === 1){
            let sucursal = data.data[0];
            setDatos({
              id: sucursal.ID_SUC,
              nombre: sucursal.NOMBRE_SUCURSAL_SUC || '',
              calle: sucursal.CALLE_SUC || '',
              num_exterior: sucursal.NUM_EXTERIOR_SUC || '',
              num_interior: sucursal.NUM_INTERIOR_SUC || '',
              colonia: sucursal.COLONIA_SUC || '',
              codigo_postal: sucursal.CODIGO_POSTAL_SUC || '',
              ciudad: sucursal.CIUDAD_SUC || '',
              estado: sucursal.ESTADO_SUC || '',
              lat: sucursal.LATITUD_SUC || 0.0,
              lon: sucursal.LONGITUD_SUC || 0.0,
            });
          }
          setIsLoading(false);
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
    else{      
      setIsLoading(false);
    }
  }, [id]);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <FormSucursal datos={datos} handleChange={handleChange} handleSave={handleSave} error={error} />}
      </MasterLayout>
    </>
  );
};

export default DetalleSucursalPage;
